type StarIconProps = {
  size?: number;
  color?: string;
  variant?: "filled" | "outline";
};

const StarIcon = ({ size = 19, color = "#2A85FF", variant = "filled" }: StarIconProps) => {
  if (variant === "outline") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.73112 20.8325C7.22404 21.0972 6.6106 21.0506 6.14933 20.7124C5.68807 20.3741 5.45921 19.8031 5.55921 19.2399L6.36855 14.6009L2.96113 11.3356C2.54463 10.9384 2.39199 10.338 2.56823 9.7901C2.74446 9.24222 3.21852 8.84339 3.78847 8.76351L8.51945 8.08723L10.6553 3.82645C10.9086 3.31546 11.4296 2.99219 11.9999 2.99219C12.5702 2.99219 13.0912 3.31546 13.3445 3.82645L15.4803 8.08723L20.2113 8.76351C20.7813 8.84339 21.2553 9.24222 21.4316 9.7901C21.6078 10.338 21.4552 10.9384 21.0387 11.3356L17.6312 14.6009L18.4406 19.2409C18.5406 19.8041 18.3117 20.3751 17.8505 20.7134C17.3892 21.0516 16.7757 21.0982 16.2687 20.8335L11.9999 18.6276L7.73112 20.8325Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23502 17.8403C4.72795 18.105 4.11451 18.0584 3.65324 17.7202C3.19197 17.3819 2.96311 16.8109 3.06312 16.2477L3.87246 11.6088L0.465037 8.34339C0.0485385 7.9462 -0.104102 7.34579 0.072132 6.79791C0.248366 6.25003 0.722424 5.85121 1.29238 5.77132L6.02335 5.09504L8.15924 0.834266C8.41249 0.323275 8.9335 0 9.5038 0C10.0741 0 10.5951 0.323275 10.8484 0.834266L12.9843 5.09504L17.7152 5.77132C18.2852 5.85121 18.7592 6.25003 18.9355 6.79791C19.1117 7.34579 18.9591 7.9462 18.5426 8.34339L15.1351 11.6088L15.9445 16.2487C16.0445 16.8119 15.8156 17.3829 15.3544 17.7212C14.8931 18.0594 14.2797 18.106 13.7726 17.8414L9.5038 15.6354L5.23502 17.8403Z"
        fill={color}
      />
    </svg>
  );
};

export default StarIcon;
